module.exports = __webpack_public_path__ + "img/logo-esteso-colore-negativo.aec990ed.svg";